import { FC, PropsWithChildren } from 'react';

import { Box, Button, Card, Stack, SxProps, Theme } from '@mui/material';
import { grey } from '@mui/material/colors';

/**
 * Кнопка действия карточки: под контентом делит ряд пополам, в боковой колонке
 * (от sm2) — ширина по содержимому, как было. `minHeight` добирает тач-цель до
 * 44px: у текстовой кнопки «Удалить» тема даёт 42px.
 */
const ACTION_BUTTON_SX: SxProps<Theme> = {
  flex: { xs: '1 1 0', sm2: '0 0 auto' },
  minHeight: 44
};

interface IProps {
  onChangeClick?: () => void;
  onDeleteClick?: () => void;
  isDisabled?: boolean;
}

/**
 * Какрточка с возможностью редактирования элемента
 * @param root0 Пропсы
 * @param root0.children Доченрие элементы
 * @param root0.onChangeClick Колбэк при клике на Изменить
 * @param root0.onDeleteClick Колбэк при клике на Удалить
 * @param root0.isDisabled Задизейблина ли форма
 */
export const EditableItemCard: FC<PropsWithChildren<IProps>> = ({
  children,
  onChangeClick,
  onDeleteClick,
  isDisabled = false
}) => {
  return (
    <Card sx={{ backgroundColor: grey[50] }}>
      <Stack
        sx={{
          // Ниже sm2 действия уходят под контент. В ряду они забирали 105px из
          // 328px карточки (32%) и оставляли колонке названия 189px: название
          // «Аватар: Легенда о Корре» разбивалось на две строки, а период
          // съёмок — ещё на две. Действия строки списка не должны конкурировать
          // за ширину с самим содержимым строки.
          flexDirection: { xs: 'column', sm2: 'row' },
          alignItems: { xs: 'stretch', sm2: 'flex-start' },
          justifyContent: 'space-between',
          gap: { xs: 4, sm2: 0 }
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>

        {onChangeClick && onDeleteClick && (
          <Stack
            sx={{
              // Под контентом кнопки встают в ряд и делят его пополам; в боковой
              // колонке (от sm2) остаются столбиком, как было
              flexDirection: { xs: 'row', sm2: 'column' },
              gap: 2,
              flexShrink: 0
            }}
          >
            <Button
              variant='contained'
              onClick={onChangeClick}
              disabled={isDisabled}
              sx={ACTION_BUTTON_SX}
            >
              Изменить
            </Button>

            <Button
              color='error'
              onClick={onDeleteClick}
              disabled={isDisabled}
              sx={ACTION_BUTTON_SX}
            >
              Удалить
            </Button>
          </Stack>
        )}
      </Stack>
    </Card>
  );
};
